<template>
    <div id="ComponentTransactionCreate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="itemHeader" v-if="$route.params.id > 0">Update Part Transaction</span>
                    <span class="page-title" id="itemHeader" v-else>Add Part Transaction</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackItemList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content component-transaction-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="ComponentTransactionForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="category_id">Part:</label>
                                        <v-select v-model="component_id" name="component_id" @input="changeItem" label="text" :filterable="false" :options="componentArr" @search="onSearchComponent" placeholder="Search Part" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Part...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ component_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="location_id">Location:</label>
                                        <v-select v-model="location_id" name="location_id" placeholder="Select Location."
                                                label="text"
                                                :options="locationArr" @change="changeLocation($event)">
                                        </v-select>
                                        <div class="field-error">{{locationerrors}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="warehouse_id">Warehouse:</label>
                                        <v-select v-model="warehouse_id" name="warehouse_id"  @input="changeWarehouse($event)" placeholder="Select Warehouse."
                                                label="text"
                                                :options="warehouseArr">
                                        </v-select>
                                        <div class="field-error">{{warehouseerrors}}</div>
                                    </div>
                                     <div class="col form-group">
                                        <label class="control-label" for="rsb_id">R/S/B:</label>
                                        <v-select v-model="rsb_id" name="rsb_id" placeholder="R/S/B."
                                                label="text"
                                                :options="rsbArr">
                                        </v-select>
                                        <div class="field-error">{{rsb_iderror}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="vendor_id">Vendor:</label>
                                        <v-select v-model="vendor_id" name="vendor_id"
                                                label="text" :filterable="false" :options="vendorArr"
                                                @search="onSearchVendor"
                                                placeholder="Select Vendor Code or Name" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Vendor Code or Name...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="location_shelf">Base Price:</label>
                                        <input type="text" class="form-control" v-model="base_price" id="base_price" @keypress="isNumberKey($event)" placeholder="Enter Base Price" name="base_price">
                                        <div class="field-error">{{base_price_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="quantity">Quantity:</label>
                                        <input type="text" class="form-control" v-model="quantity" id="quantity" @keypress="isAmountCheck($event)" placeholder="Enter Quantity" name="quantity">
                                        <div class="field-error"></div>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="purchase_unit_id">Purchase UOM:</label>
                                        <input type="text" :disabled="true" class="form-control" v-model="purchase_unit_id" id="purchase_unit_id" placeholder="Purchase Unit" name="purchase_unit_id">
                                    </div> -->
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="location_row">Location Row:</label>
                                        <input type="text" class="form-control" v-model="location_row" id="location_row" placeholder="Enter Location Row" name="location_row">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="location_bin">Location Bin:</label>
                                        <input type="text" class="form-control" v-model="location_bin" id="location_bin" placeholder="Enter Location Bin" name="location_bin">
                                        <div class="field-error"></div>
                                    </div> 
                                    <div class="col form-group">
                                        <label class="control-label" for="location_shelf">Location Shelf:</label>
                                        <input type="text" class="form-control" v-model="location_shelf" id="location_shelf" placeholder="Enter Location Shelf" name="location_shelf">
                                    </div> -->
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateComponentTransactionBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateComponentTransaction" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateComponentTransactionBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateComponentTransaction" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueItemBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateComponentTransaction(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelItemBtn" class="btn btn-tertiary" v-on:click.prevent="BackItemList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import {contractMixins} from '../mixins/contractMixins';
export default {
  name: "ItemCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Part Transaction | " +process.env.COPYRIGHT_NAME : "Add Part Transaction | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    vendor_id: null,
    vendorArr: [],
    quantity: 0,
    location_id: null,
    locationArr: [],
    location_row: "",
    location_shelf: "",
    location_bin: "",
    loading:false,
    locationerrors:'',
    base_price:0,
    base_price_error_msg:'',
    warehouse_id:'',
    warehouseerrors:'',
    component_id:'',
    component_error_msg:'',
    componentArr:[],
    // purchase_unit_id:'',
    stock_unit_id:'',
    warehouseArr:[],
    bill_item_Id:'',
    billItemArr:[],
    woCompArr:[],
    wo_comp_id:'',
    rsb_id:'',
    rsbArr:[],
    rsb_iderror:''

  }),
  watch:{
    //check permission change
    permissions: function (permissions) {

        var self = this;
        if (permissions.length > 0) {
            for (var i = 0; i < permissions.length; i++) {
                if (permissions[i].name == 'add_component_transaction') {
                    self.cantAccessPage = true;
                }
            }
        }

    }
  },
  created: function() {

  },
  mounted: function() {

        var self = this;
        // console.log("Default " + self.expenseValue);
        self.getPermissions();
        //load locations
        self.loadFieldData(['location']);

        var path = window.location.pathname;
        var segments = path.split("/");
        
        if (segments[3]) {

            self.loadItem();
        }

        if (self.$route.query.inv_id != undefined && self.$route.query.inv_id > 0){
            self.loadInventory(self.$route.query.inv_id);
        }else{
            var userObj = JSON.parse(localStorage.getItem("user_obj"));
            if(userObj != null && userObj["location_id"] != null){
                self.location_id =  {value: userObj["location_id"], text: self.titleCase(userObj["locationName"]) + " (" + userObj["locationCode"] + ")"};  
            }
        }
  },
  methods: {
    
    onSearchVendor(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'vendor', '');
        }
    },
    onSearchComponent(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'component', '');
        }
    },
    
    BackItemList() {
      var self = this;
      if (self.$route.query.inv_id != undefined && self.$route.query.inv_id > 0){
        
        self.$router.push("/part-transaction/list/"+self.$route.query.inv_id);

      }else{
        
        self.$router.push("/pdc-stock/list");

      }
    },

    CreateComponentTransaction(flag) {
        var self = this;
        var error = false;

        self.warehouseerrors = "";
        self.locationerrors = "";
        self.base_price_error_msg = '';
        self.rsb_iderror = "";

        var checkNumber = /^[0-9]+(\.[0-9]+)?$/;
        
        if (self.base_price == "" && self.base_price != 0) {
            self.base_price_error_msg = "Base Price Required.";
            error = true;
        } else {
            
            //check amount is valid or not
            if ( !String(self.base_price).match(checkNumber) ) {
                self.base_price_error_msg = "Base Price is not valid.";
                error = true;
            }
        }
        if (self.component_id == null || self.component_id == '' || !self.component_id.value) {
            self.component_error_msg = "Part is Required.";
            error = true;
        } 
        if (self.location_id == null || self.location_id == '' || !self.location_id.value) {
            self.locationerrors = "Location is Required.";
            error = true;
        } 
        if (self.warehouse_id == null || self.warehouse_id == '' || !self.warehouse_id.value) {
            self.warehouseerrors = "Warehouse Required.";
            error = true;
        }
        // if (self.rsb_id == null || self.rsb_id == '' || !self.rsb_id.value) {
        //     self.rsb_iderror = "R/S/B Required.";
        //     error = true;
        // } 

        if (!error) {

            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateComponentTransactionBtn").val("Updating ...");
                $("#CreateComponentTransactionBtn").prop("disabled", true);
                $("#cancelItemBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueItemBtn").val("Saving ...");
                    $("#CreateComponentTransactionBtn").prop("disabled", true);
                    $("#createAndContinueItemBtn").prop("disabled", true);
                    $("#cancelItemBtn").prop("disabled",true);

                }else{

                    $("#CreateComponentTransactionBtn").val("Saving ...");
                    $("#CreateComponentTransactionBtn").prop("disabled", true);
                    $("#createAndContinueItemBtn").prop("disabled", true);
                    $("#cancelItemBtn").prop("disabled",true);
                }  
            }
            
            var fields = $("#ComponentTransactionForm").serializeArray();
            fields.push({ name: "id", value: segments[3] });
            if(self.component_id == null) {
                fields.push({ name: "item_id", value: '' });
            } else {
                fields.push({ name: "item_id", value: self.component_id.value });
            }
            if (self.vendor_id == null) {
                fields.push({name: "vendor_id", value: ""});
            } else{
                fields.push({name: "vendor_id", value: self.vendor_id.value});
            }

            // if (self.wo_comp_id == null) {
            //     fields.push({name: "wo_comp_id", value: ""});
            // } else{
            //     fields.push({name: "wo_comp_id", value: self.wo_comp_id.value});
            // }
            // if (self.wo_comp_id == null) {
            //     fields.push({name: "wo_id", value: ""});
            // } else{
            //     fields.push({name: "wo_id", value: self.wo_comp_id.wo_id});
            // }

            // if (self.bill_item_Id == null) {
            //     fields.push({name: "bill_item_id", value: ""});
            // } else{
            //     fields.push({name: "bill_item_id", value: self.bill_item_Id.value});
            // }
            // if (self.bill_item_Id == null) {
            //     fields.push({name: "bill_id", value: ""});
            // } else{
            //     fields.push({name: "bill_id", value: self.bill_item_Id.bill_id});
            // }

            if (self.location_id == null) {
                fields.push({name: "location_id", value: ""});
            } else{
                fields.push({name: "location_id", value: self.location_id.value});
            }
            fields.push({ name: "warehouse_id", value: self.warehouse_id.value });
            if (self.location_id == null) {
                fields.push({name: "rsb_id", value: ""});
            } else{
                fields.push({name: "rsb_id", value: self.rsb_id.value});
            }

            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/component-transaction/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateComponentTransactionBtn").val("Update");
                        $("#CreateComponentTransactionBtn").prop("disabled", false);
                        $("#cancelItemBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueItemBtn").val("Save and Continue");
                            $("#CreateComponentTransactionBtn").prop("disabled", false);
                            $("#createAndContinueItemBtn").prop("disabled", false);
                            $("#cancelItemBtn").prop("disabled",false);

                        }else{

                            $("#CreateComponentTransactionBtn").val("Save");
                            $("#CreateComponentTransactionBtn").prop("disabled", false);
                            $("#createAndContinueItemBtn").prop("disabled", false);
                            $("#cancelItemBtn").prop("disabled",false);

                        }
                    }

                    if (data.code == 201) {
                        self.$swal('',data.content,'info');
                        return;
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#ComponentTransactionForm").trigger("reset");
                            self.component_id = null;
                            // self.warehouse_id = null;
                            self.vendor_id = null;
                            self.quantity = "";
                            self.location_id = null;
                            self.location_row = "";
                            self.location_shelf = "";
                            self.location_bin = "";
                            self.base_price = '';
                            self.stock_unit_id = '';
                            // self.purchase_unit_id = '';
                            self.warehouse_id = null;
                            self.rsb_id = null;
                            self.warehouseArr = [];
                            self.rsbArr = [];

                        }else{
                            
                            if (self.$route.query.inv_id != undefined && self.$route.query.inv_id > 0){
        
                                self.$router.push("/part-transaction/list/"+self.$route.query.inv_id);

                            }else{
                                
                                self.$router.push("/pdc-stock/list");

                            }
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateComponentTransactionBtn").val("Update");
                        $("#CreateComponentTransactionBtn").prop("disabled", false);
                        $("#cancelItemBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#ComponentTransactionForm").trigger("reset");

                            $("#createAndContinueItemBtn").val("Save and Continue");
                            $("#CreateComponentTransactionBtn").prop("disabled", false);
                            $("#createAndContinueItemBtn").prop("disabled", false);
                            $("#cancelItemBtn").prop("disabled",false);

                        }else{

                            $("#CreateComponentTransactionBtn").val("Save");
                            $("#CreateComponentTransactionBtn").prop("disabled", false);
                            $("#createAndContinueItemBtn").prop("disabled", false);
                            $("#cancelItemBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'component-create')
                }
            });
        }else{
            self.errorValidationFocus();
        }

    },

    loadItem() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/component-transaction/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {

                    if(data.content.itemId == null) {
                        self.component_id = null;
                    }else{
                        self.component_id = {value: data.content.itemId, text: self.titleCase(data.content.itemName + " (" + data.content.itemCode +")")};
                    }
                    // self.purchase_unit_id = data.content.mUnitName;
                    if(data.content.vendor_id == null) {
                        self.vendor_id = null;
                    }else{
                        self.vendor_id = {value: data.content.vendor_id, text: data.content.veCode+' | '+self.titleCase(data.content.veName)};
                    } 
                    self.quantity = data.content.quantity;

                    if(data.content.location_id == null) {
                        self.location_id = null;
                    }else{
                        self.location_id = {value: data.content.location_id, text: self.titleCase(data.content.locationName)+' | '+data.content.locCode};
                    }

                    //  if(data.content.warehouse_id == null) {
                    //     self.warehouse_id = null;
                    // }else{
                    //     self.warehouse_id = {value: data.content.warehouse_id, text: data.content.warehouseCode+' | '+data.content.warehouseName};
                    // }

                    // if(data.content.billitemid == null) {
                    //     self.bill_item_Id = null;
                    // }else{
                    //     self.bill_item_Id = {value: data.content.billitemid, text: data.content.voucher_number+' | '+data.content.billitemName+' | '+data.content.billqty};
                    // }

                    // if(data.content.wocompid == null) {
                    //     self.wo_comp_id = null;
                    // }else{
                    //     self.wo_comp_id = {value: data.content.wocompid, text: data.content.work_order_no+' | '+data.content.woitemName+' | '+data.content.woqty};
                    // }

                    if (data.content.location_row == 0) {
                        self.location_row = "";
                    } else{
                        self.location_row = data.content.location_row;
                    }

                    if (data.content.location_bin == 0) {
                        self.location_bin = "";
                    } else{
                        self.location_bin = data.content.location_bin;
                    }

                    self.location_shelf = data.content.location_shelf;
                    self.base_price = data.content.base_price;
                    if(data.content.warehouse_id == null) {
                        self.warehouse_id = null;
                    }else{
                        self.warehouse_id = {value: data.content.warehouse_id, text: self.titleCase(data.content.warehouseCode)+' | '+data.content.warehouseName};
                        self.loadFieldData(['rsb'],self.warehouse_id.value);
                    }

                    if(data.content.warehouse_bin_mapper_id == null) {
                        self.rsb_id = null;
                    }else{
                        var row = '';
                        var shelf = '';
                        var bin = '';
                        if (data.content.rsb_row != null){
                            row = data.content.rsb_row;
                        }
                        if (data.content.rsb_shelf != null){
                            shelf = data.content.rsb_shelf;
                        }
                        if (data.content.rsb_bin != null){
                            bin = data.content.rsb_bin;
                        }
                        self.rsb_id = {value: data.content.warehouse_bin_mapper_id, text: row+' | '+shelf+' | '+bin};
                    }
                    
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'component-by-id')
            }
        });
    },
    loadInventory(invid) {
        
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        
        $.ajax({
            url: process.env.ROOT_API + "/component-inventory/" + invid,
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {

                    if(data.content.itemId == null) {
                        self.component_id = null;
                    }else{
                        self.component_id = {value: data.content.itemId, text: self.titleCase(data.content.itemName + " (" + data.content.itemCode +")")};
                    }

                    if(data.content.location_id == null) {
                        self.location_id = null;
                    }else{
                        self.location_id = {value: data.content.location_id, text: self.titleCase(data.content.locationName)+' | '+data.content.locCode};
                    }

                    // if (data.content.location_row == 0) {
                    //     self.location_row = "";
                    // } else{
                    //     self.location_row = data.content.location_row;
                    // }

                    // if (data.content.location_bin == 0) {
                    //     self.location_bin = "";
                    // } else{
                    //     self.location_bin = data.content.location_bin;
                    // }

                    // self.location_shelf = data.content.location_shelf;
                    
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'component-by-id')
            }
        });
    },
    changeItem:function(event){
        
        // this.purchase_unit_id = this.component_id.mUnitName;
        return;
    },
    isNumberKey: function(evt) {
        
        var self = this;

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
            evt.preventDefault();            
        } else {
            return true;
        }
    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    changeLocation:function(){
        var self = this;

        if (self.location_id != null && self.location_id.value){
            self.loadFieldData(['warehouse'],self.location_id.value);
        }
    },

    changeWarehouse:function(){
        var self = this;

        if (self.warehouse_id != null && self.warehouse_id.value){
            self.loadFieldData(['rsb'],self.warehouse_id.value);
        }
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ComponentTransactionCreate.vue